import React from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";

// Lightbox foto sederhana: klik luar atau tombol tutup untuk menutup.
export const FotoLightbox = ({ src, alt, onClose }) => {
  if (!src) return null;
  return createPortal(
    <div className="fixed inset-0 z-[100] bg-black/80 backdrop-blur-sm flex items-center justify-center p-4" onClick={onClose} data-testid="foto-lightbox">
      <button type="button" onClick={onClose} aria-label="Tutup" className="absolute top-4 right-4 h-11 w-11 rounded-full bg-white/10 hover:bg-white/25 text-white flex items-center justify-center" data-testid="foto-lightbox-tutup"><X className="h-5 w-5" /></button>
      <figure className="max-w-[92vw] max-h-[88vh] flex flex-col items-center gap-3" onClick={(e) => e.stopPropagation()}>
        <img src={src} alt={alt || ""} className="max-w-[92vw] max-h-[80vh] rounded-2xl object-contain shadow-2xl" data-testid="foto-lightbox-img" />
        {alt && <figcaption className="text-white/90 text-sm font-medium">{alt}</figcaption>}
      </figure>
    </div>,
    document.body
  );
};
